import React, { useEffect, useState, useRef } from "react";
import classes from "./Payables.module.css";
import HeaderNav from '../../Accoungting/HeaderNav/HeaderNav';
import Footer from "../../Accoungting/Footer/Footer";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../../Assets/searchicon.png";
import filter from "../../../Assets/filter.png";
import { Pen, Trash2, Printer } from "lucide-react";
import axios from "axios";
import { BASE_URL } from '../../../Components/Styles/API/API';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Button, Modal, Form, Spinner, Tab, Tabs, Row, Col, Popover } from 'react-bootstrap';
import Select from "react-select";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import Swal from "sweetalert2";
import CurrencyInput from "react-currency-input-field";
// import PayableEntryModal from "../../Accounting/Payments/CashReciept/PayableEntryModal";






const PayablesEntries = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleShow1 = () => setShow1(true);
  const handleShow2 = () => setShow2(true);
  const handleClose1 = () => setShow1(false);
  const handleClose2 = () => setShow2(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [description, setDescription] = useState("");
  const [accountExpenses, setAccountExpenses] = useState("");
  const [accountCode, setAccountCode] = useState("");
  const [accountPayables, setAccountPayables] = useState("");
  const [amount, setAmount] = useState("");
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [bankOptions2, setBankOptions2] = useState([]);
  const [supplierOptions2, setSupplierOptions2] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedPayableType, setSelectedPayableType] = useState(null);
  const [selectedBank2, setSelectedBank2] = useState(null);
  const [selectedSupplier2, setSelectedSupplier2] = useState(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [addpaymenntLoad, setAddPaymenntLoad] = useState(false);
  const [addpaymenntLoad2, setAddPaymenntLoad2] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [totalEntries, setTotalEntries] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [bearer, setBearer] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPayee, setIsLoadingPayee] = useState(false);
  const [currLoading, setCurrLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [user, setUser] = useState('');
  const [userID, setUserID] = useState('');
  const [currency, setCurrency] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedBankAc, setSelectedBankAc] = useState('');
  const [selectedBankName, setSelectedBankName] = useState('');
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");  
  const [currentMonth, setCurrentMonth] = useState('');
  const [selectOptions1, setSelectOptions1] = useState([]);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
    
  




  
    const readData = async () => {
      try {
        const value = localStorage.getItem('userToken');
        const value1 = localStorage.getItem('tobi');
        const valueID = localStorage.getItem('tobiID');
        const current = localStorage.getItem('currentMonth');
        console.log(value);  
  
        if (value !== null && value.trim() !== '') {
          setBearer(value);
          console.log(bearer)
        } else {
          navigate('/login');
          return;
        }  
        if (value1 !== null) {
          setUser(value1);
        }
        if (valueID !== null) {
          setUserID(valueID);
        }
      if (current !== null) {
        console.log(current)
        const date = new Date(current);  // Assume current is in a parsable date format

        setCurrentMonth(date);
        const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        // Set the min and max date for the date input

        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');  // Add leading zero
          const day = String(date.getDate()).padStart(2, '0');         // Add leading zero
          return `${year}-${month}-${day}`;
      };
        
        setMinDate(formatDate(startOfMonth));
        setMaxDate(formatDate(endOfMonth));

       console.log(formatDate(startOfMonth), formatDate(endOfMonth));

      }
  
      } catch (e) {
        alert('Failed to fetch the input from storage');
      }
    };
  
    useEffect(() => {
      readData();
    }, []);

      // Handlers that persist changes 
      const handleDateChange = (e) => { 
        const value = e.target.value; 
        setSelectedDate(value); 
      }; 
      
      const handleBankChangeNew12 = (option) => { 
        setSelectedPayableType(option); 
      }; 

      const handleBankChangeNew = (selectedOption) => {
        setSelectedPayableType(selectedOption);
        setSelectedBank2(null);
        setSelectedBank(null);
        setSelectedSupplier2(null);
        setAccountCode("");
        if (selectedOption) {
          fetchPayablessss(selectedOption.value); // pass the ID directly
        }
      };

      
      const handleSupplierChange = (option) => { 
        if (option) { 
          setSelectedSupplier2(option); 
          setAccountExpenses(option?.expense || ""); 
          setAccountPayables(option?.payable || ""); 
        } else { 
          setSelectedSupplier2(null); 
          setAccountExpenses(""); 
          setAccountPayables(""); 
        } 
      }; 
      
      const handleAmountChange = (value) => { 
        setAmount(value); 
      }; 
      
      const handleDescriptionChange = (e) => { 
        setDescription(e.target.value); 
      };

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  


  const printRef = useRef();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };


    const handleRadioChange = (e) => {
    const value = e.target.value;
    setSelectedRadio(value);

    if (value === "general") {
      setSelectedCustomer(null);
    }
  };

    const handleDateChangeNew = (event) => {
    setSelectedDate(event.target.value);
  };


    const handleBankChange = (selectedOption) => {
    setSelectedBank(selectedOption.value);
    setSelectedBankName(selectedOption.label);
    setSelectedBankAc(selectedOption.acNo);
  };


  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     try {
  //       const token = localStorage.getItem("authToken");
  //       const res = await axios.get(`${BASE_URL}/v1/payments-made`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //           },
  //         }
  //       );
  //       if (res.data && res.data.status && Array.isArray(res.data.data)) {
  //         setInvoices(res.data.data);
  //       }
  //     } catch (err) {
  //       // Optionally handle error
  //       setInvoices([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchInvoices();
  // }, []);

    const handlePrevPage = () => {
    setCurrentPage(Math.max(currentPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(Math.min(currentPage + 1, totalPages));
  };

  // const totalEntries = filteredData.length;
  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);


  const handleCheckboxChange = (row) => {
  const selectedIndex = selectedRows.findIndex(item => item.id === row.id);
  let updatedSelectedRows = [];

  if (selectedIndex === -1) {
    updatedSelectedRows = [...selectedRows, row];
  } else {
    updatedSelectedRows = selectedRows.filter(item => item.id !== row.id);
  }

  setSelectedRows(updatedSelectedRows);
  setSelectAll(updatedSelectedRows.length === tableData.length);
};

const isSelected = (row) => {
  return selectedRows.some(item => item.id === row.id);
};

    const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    setSelectedRows(isChecked ? [...tableData] : []);
    // console.log(isChecked ? [...tableData] : []);
  };

    const fetchInvoices = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/payments-made`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setInvoices(res.data.data);
        }
      } catch (err) {
        setInvoices([]);
      } finally {
        setLoading(false);
      }
    };

    // load invoices on mount
    useEffect(() => {
      fetchInvoices();
    }, []);

  //   const fetchExpenses = async () => {
  //   setIsLoading(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL}/fetch-all-payments?page=${currentPage}`, { headers });

  //     const results = response.data?.data?.data;
  //     const resultx = response.data?.data?.total;
  //     setTotalEntries(resultx);
  //     setTableData(results);
  //     // console.log(results, "accounts");
  //     const total = response.data?.data?.last_page || 1;
  //     setTotalPages(total);
  //   } catch (error) {
  //     const errorStatus = error.response?.data?.message;
  //     console.log(errorStatus);
  //     setTableData([]);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

    const fetchPending = async () => {
    setIsLoadingPayee(true);
    try {
        const response = await axios.get(`${BASE_URL}/fetch-pending-payables`, { headers });
        const results = response.data?.data;       

        setTableData(results);
        console.log("response:", response);
      
    } catch (error) {
        if (error.response && error.response.status === 401) {
            navigate('/login');
        } else {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                console.log(errorMessage);
              }
          }
            setTableData([]);
        }
    } finally {
      setIsLoadingPayee(false);
    }
  };

    const fetchDebit = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/account/bank-accounts`, { headers });
        const debitAcct = response.data?.data;
  
        const options1 = debitAcct.map((item) => ({
          label: item.gl_name,
          value: item.id,
          acNo: item.gl_code,
        }));
  
        setTableData1(debitAcct);
        setSelectOptions1(options1);
      } catch (error) {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setTableData1([]);
      } finally {
        setIsLoading(false);
      }
    };
  
  
  
  useEffect(() => {
    if (bearer) {
      fetchPending();
      fetchDebit();
    }
  }, [bearer]);

    const fetchCurrency = async () => {
        setCurrLoading(true);
        try {
            const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
            const results = response.data?.data;
            // console.log(results, "currencis")
            const options = results.map((item) => ({
                label: item.name || item.code,
                value: item.id,
                symbol: item.symbol
            }));
            setCurrency(results);
            setCurrencyOptions(options);
        } catch (error) {
            const errorStatus = error.response?.data?.message;
            console.log(errorStatus);
            setCurrency([]);
        } finally {
            setCurrLoading(false);
        }
    };

  useEffect(() => {
    if (bearer) {
      // fetchExpenses();
      fetchCurrency();
      //   fetchTotalExpenses();
    }
  }, [bearer, currentPage]);


    useEffect(() => {
      const fetchCurrencies = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/fetch-all-currencies`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.name || item.code,
            }))
            : [];
          setCurrencyOptions(options);
        } catch (err) {
          setCurrencyOptions([]);
        }
      };
      fetchCurrencies();
    }, []);


      const fetchBank = async () => {
        setIsLoading(true);
        try {
          const response = await axios.get(`${BASE_URL}/account/expenses`, { headers });
          const results = response.data?.data;
    
          const opt1 = results.map((item) => ({
            value: item.id,
            label: item.gl_name,
            gl_code: item.gl_code,
          }));

          console.log(response);
          setBankOptions(opt1);
    
        } catch (error) {
          const errorStatus = error.response?.data?.message;
          console.log(errorStatus);
          setBankOptions([]);
        } finally {
          setIsLoading(false);
        }
      };

      const fetchBank2 = async () => {
        setIsLoading(true);
        try {
          const response = await axios.get(`${BASE_URL}/account/payables`, { headers });
          const results = response.data?.data;
    
          const opt1 = results.map((item) => ({
            value: item.id,
            label: item.gl_name,
          }));
          console.log(response);
          setBankOptions2(opt1);
        } catch (error) {
          const errorStatus = error.response?.data?.message;
          console.log(errorStatus);
          setBankOptions2([]);
        } finally {
          setIsLoading(false);
        }
      };

      const fetchPaymentModeNew = async () => {
        setIsLoading(true);
        try {
          const response = await axios.get(`${BASE_URL}/income/get-payment-method`, { headers });
          const results = response.data?.data;
            console.log("newresult", results);
            const options = results.map((item) => ({
                label: item.name || item.code,
                value: item.id,
                // symbol: item.symbol
            }));
          setPaymentMode(options);

        } catch (error) {
          const errorStatus = error.response?.data?.message;
          console.log(errorStatus);
          setPaymentMode([]);
        } finally {
          setIsLoading(false);
        }
      };
    
      useEffect(() => {
        if (bearer) {
          fetchBank();
          fetchBank2();    
          fetchPaymentModeNew();    
        }
      }, [bearer]);





      useEffect(() => {
        const fetchCustomers = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${BASE_URL}/v1/beneficiary`, {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });
            // Assuming response data is an array of currencies or customers
            const options = Array.isArray(res.data.data)
              ? res.data.data.map((item) => ({
                value: item.id,
                label: item.name,
              }))
              : [];
            setCustomerOptions(options);
          } catch (err) {
            setCustomerOptions([]);
          }
        };
        fetchCustomers();
      }, []);

      useEffect(() => {
        const fetchInvoiceOptions = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${BASE_URL}/v1/fetch-pending-purchases-invoice`, {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });
            console.log(res);
            // Assuming response data is an array of currencies or customers
            const options = Array.isArray(res.data.data)
              ? res.data.data.map((item) => ({
                value: item.id,
                label: `${item.invoice_number} - ${item.supplier?.name}`,
                balance: item.balance,
              }))
              : [];
            setInvoiceOptions(options);
          } catch (err) {
            setInvoiceOptions([]);
          }
        };
        fetchInvoiceOptions();
      }, []);
  

  // Skeleton loader rows
  // const SkeletonRows = () => (
  //   <>
  //     {[...Array(5)].map((_, idx) => (
  //       <tr key={idx}>
  //         {Array(10).fill().map((_, i) => (
  //           <td key={i}>
  //             <div className={classes.skeletonLoader}></div>
  //           </td>
  //         ))}
  //       </tr>
  //     ))}
  //   </>
  // );

  // Helper for status
  const statusClass = (status) => {
    if (status === "Success") return classes.greenStatus;
    if (status === "Pending") return classes.yellowStatus;
    return classes.redStatus;
  };

    // useEffect(() => {
    //   const link = document.createElement("link");
    //   link.rel = "stylesheet";
    //   link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
    //   document.head.appendChild(link);
    //   return () => {
    //     document.head.removeChild(link);
    //   };
    // }, []);

  const addPayment = async () => {
    setAddPaymenntLoad(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${BASE_URL}/v1/pay-purchase-invoice`, 

        {
          payment_type: selectedRadio,
          transaction_date: paymentDate,
          supplier_id: selectedCustomer?.value,
          supplier: customerName,
          description: description,
          payment_mode: selectedPaymentMode?.value,
          currency: selectedCurrency?.value,
          amount: amount,
          credit: selectedBank?.value,
          debit: selectedBank2?.value,
        },
        { headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });

          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });

          fetchInvoices();
          handleClose1();
          setDescription("");
          setAmount("");
          setCustomerName("");
          setPaymentDate("");
          setSelectedRadio("");
          setSelectedBank(null);
          setSelectedBank2(null);
          setSelectedCurrency(null);
          setSelectedCustomer(null);
          setSelectedPaymentMode(null);
      
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }
    } finally {
      setAddPaymenntLoad(false);
    }
  };

      const payablesType = [
  { value: "1", label: "Supllier/Contractor" },
  // { value: "1", label: "Salary Payables" },
  { value: "2", label: "PAYE" },
  { value: "3", label: "Pension" },
  { value: "4", label: "HMO" },
  // { value: "5", label: "General" },
];

  const addPayment2 = async () => {
    setAddPaymenntLoad2(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/post-payable-entries`, 

        {
          transaction_date: selectedDate,
          type: selectedPayableType?.value,
          type_name: selectedPayableType?.label,
          description: description,
          supplier_id: selectedSupplier2?.value,
          expense_gl: selectedBank?.value,
          payable_gl: selectedBank2?.value,
          currency: selectedCurrency?.value,
          payment_mode: selectedPaymentMode?.value,
          amount: amount,
        },
        { headers: {
                Authorization: `Bearer ${bearer}`,
                Accept: "application/json",
              },
            });

          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });

          fetchPending();
          handleClose2();
          setSelectedDate(null);
          setSelectedPayableType(null);
          setDescription("");
          setSelectedSupplier2(null);
          setSelectedBank(null);
          setSelectedBank2(null);
          setAmount("");
      
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }
    } finally {
      setAddPaymenntLoad2(false);
    }
  };

  const handleBankChangeNew22 = (selectedOption) => {
  setSelectedPayableType(selectedOption);
  if (selectedOption) {
    fetchPayablessss(selectedOption.value); // pass the ID directly
  }
};

const fetchPayablessss = async (bankId) => {
  setAddPaymenntLoad(true);
  try {
  const token = localStorage.getItem("userToken");    
  console.log(token);
    const response = await axios.get(
      `${BASE_URL}/beneficiary/get-selected-suppliers`,
      {
        params: { id: bankId }, // ✅ query string
        headers: {
          Authorization: `Bearer ${bearer}`,
          Accept: "application/json",
        },
      }
    );

    const resultss = response.data.data;
    const options = resultss.map((item) => ({
        label: item?.name,
        value: item?.id,
        expense: item?.expense?.gl_name,   // ✅ include expense_gl
        payable: item?.payable?.gl_name,
        gl_codepayable: item?.payable?.gl_code,
        gl_code: item?.expense?.gl_code,
    }));
    setSupplierOptions2(options);

  } catch (error) {
    let errorMessage = "An error occurred. Please try again.";
    if (
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      if (typeof error.response.data.message === "string") {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join("; ");
      } else if (typeof error.response.data.message === "object") {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }

    Swal.fire({
      imageUrl: crop,
      imageWidth: 48,
      imageHeight: 48,
      title: "Failed!",
      confirmButtonText: "Okay",
      text: errorMessage,
      customClass: {
        title: classes.myTitle,
        popup: classes.myText,
        confirmButton: classes.myDeclineButton,
      },
      allowOutsideClick: false,
      preConfirm: () => Swal.close(),
    });
  } finally {
    setAddPaymenntLoad(false);
  }
};

    const handleNavCheque = () => {
      if (selectedRows.length !== 1) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: selectedRows.length === 0 ? 'Please select a row to generate a cheque!' : 'Please select only one row to generate a cheque!',
        });
        return;
      }
      const selectedRow = selectedRows[0]; // Get the selected row object
      const { id, description, amount, supplier, date_of_invoice, invoice_number, transaction_date, amountToPay } = selectedRow; // Destructure the selected row object
      const selectedData = { id, amountToPay, description, amount, supplier, date_of_invoice, invoice_number, transaction_date, selectedBank, selectedDate  }; // Create a new object with the required properties
      // console.log(selectedData, "pending payment");
  // console.log(selectedData)
  // return;
      navigate('/payment/cheque', { state: selectedData }); 
    }
  


  
   const handleGeneratePaymentInstruction = () => {
    if (selectedRows.length === 0) return;
    setShowPaymentModal(true);
  };
  
  
    const handleConfirmPaymentInstruction = () => {
    const rowsToPass = (selectedRows.length > 0 ? selectedRows : tableData).map((row) => ({
      ...row,
      amountToPay: row.amountToPay ?? row.balance
    }));
  
    navigate('/print_instructn', { 
      state: { rowsToPass, selectedBank, selectedDate, selectedBankName, selectedBankAc, description } 
    });
    setShowPaymentModal(false);
  };



//  const handlePrint = (rowData) => {
//   navigate("/invoice-previeww", {
//     state: {
//       invoiceNumber: rowData.invoice_number,
//       invoiceDate: rowData.invoice_date,
//       dueDate: rowData.due_date,
//       customer: {
//         name: rowData.customer_name,
//         phone_number: rowData.customer_phone,
//         email: rowData.customer_email,
//       },
//       items: rowData.items,
//       total: rowData.total,
//     },
//   });
// };

const handlePrint = (rowData) => {
  navigate("/invoice-previeww", {
    state: { invoice: rowData },
  });
};




  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

      <div className={classes.Container}>
        {/* <div className={classes.actions}>

                    <button className={`${classes.btnss} ${classes.greens}`}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={classes.btns}>Product & Services </button>

                </div> */}
        <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Payable Entries</h2>
          <h1 className={classes.Titles}>
            Manage your purchase transactions, supplier invoices, and payments.
          </h1>
        </header>

          <Row>
            <Col md={3}>
              <div className={classes.thrdkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Total Payable</p>
                  <p className={classes.kdptg1}>₦4,180,000.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>This month</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.frtkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Completed</p>
                  <p className={classes.kdptg2}>₦4,950,000.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>Completed payments</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.fiftkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Overdue</p>
                  <p className={classes.kdptg3}>₦3,200,000.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>Past due dates</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.frstkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Pending</p>
                  <p className={classes.kdptg4}>₦3,200,000.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>Total invoices</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search sales" />
            </div>
            <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Status</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div>

            <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div>
          </div>
          <div className={classes.actionsLeft}>
            {/* <button className={classes.btnss} onClick={handleGeneratePaymentInstruction} disabled={selectedRows.length === 0}> + Proceed</button> */}
            <button className={classes.btnss} onClick={handleShow2}> + Create New</button>
          </div>
        </div>

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr>
                  <th style={{ width: "5%" }}>S/N</th>
                  <th style={{ width: "7%" }}>Transaction Date</th>
                  <th style={{ width: "25%" }}>Beneficiary Name</th>
                  <th style={{ width: "45%" }}>Description</th>
                  <th style={{ width: "8%" }}>Invoice Number</th>
                  <th style={{ width: "10%" }}>Total Amount</th>
                  {/* <th>Amount</th>
                  <th>Actions</th> */}
                </tr>
              </thead>
              <tbody>

                {isLoadingPayee
                  ? Array(5)
                    .fill()
                    .map((_, idx) => (
                      <tr key={idx}>
                        {Array(6)
                          .fill()
                          .map((_, i) => (
                            <td key={i}>
                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </td>
                          ))}
                      </tr>
                    ))
                  : tableData.length === 0 ? (
                    <tr>
                      <td colSpan={10} style={{ textAlign: "center" }}>
                        No Payee found.
                      </td>
                    </tr>
                  ) : (
                    tableData.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.transaction_date}</td>
                        <td>{item.supplier?.name || item?.customer?.name}</td>
                        <td>{item.description}</td>
                        <td>{item.invoice_number}</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(item.amount).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}
                        </td>
                        {/* <td>{item.created_at ? item.created_at.split("T")[0] : ""}</td>
                        <td className={classes.actions}>
                          <Pen size={16} className={classes.editIcon} />
                          <Trash2 size={16} className={classes.deleteIcon} />
                          <Printer size={16} className={classes.printIcon} onClick={() => handlePrint(item)}
                            style={{ cursor: "pointer" }} />
                        </td> */}
                      </tr>
                    ))
                  )}
              </tbody>
            </table>
          </table>
          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button                   
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >Previous</button>
              {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return(
                <button className={classes.active}  key={page + 1}
                style={{
                  color: page + 1 === currentPage ? '#ffffff' : '#000',
                  backgroundColor: page + 1 === currentPage ? '#174384' : 'gainsboro',
                  cursor: "pointer"
                }}
                onClick={() => setCurrentPage(page + 1)}
              > {page + 1}
              </button>
                    );
                  }
                  return null;
                })}
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >Next
              </button>
              <span className={classes.pageText}>Displaying {startIndexx} - {endIndexx} of {totalEntries}</span>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show1} onHide={handleClose1} animation={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>New Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form style={{ paddingLeft: "25px", paddingRight: "25px" }}>
              <Row style={{ marginBottom: "10px"}}>
                <Col md={6}>
                  <Form.Check
                    label="Supplier/Contractor"
                    name="group1"
                    type="radio"
                    id="supplier"
                    value="supplier"
                    checked={selectedRadio === "supplier"}
                    onChange={handleRadioChange}
                    className={classes.radioGreen}
                  />
                </Col>
                <Col md={6}>
                  <Form.Check
                    label="General Payment"
                    name="group1"
                    type="radio"
                    id="general"
                    value="general"
                    checked={selectedRadio === "general"}
                    onChange={handleRadioChange}
                    className={classes.radioGreen}
                  />
                </Col>
              </Row>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Row style={{ marginBottom: "15px" }}>
                 {selectedRadio === "supplier" && (
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Payment to:</label>
                      </Col>
                      <Col md={9}>
                          <Select
                            options={customerOptions}
                            value={selectedCustomer}
                            onChange={setSelectedCustomer}
                            placeholder="Select Supplier"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                      </Col>
                    </Row>
                  </Col>
                 )}
                 {selectedRadio === "general" && (
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Payment to:</label>
                      </Col>
                      <Col md={9}>
                          <Form.Control
                            type="text"
                            value={customerName}
                            onChange={(e) => {
                              const value = e.target.value;
                              const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                              setCustomerName(filteredValue);
                            }}
                            required
                            style={{ width: "100%" }}
                          />
                      </Col>
                    </Row>
                  </Col>
                 )}
                  <Col md={12} style={{ marginBottom: 10 }}>
                        <Row>
                          <Col md={3} style={{ textAlign: "right" }}>
                              <label style={{ width: "100%" }}>Date:</label>
                          </Col>
                          <Col md={9}>
                            <Form.Control
                              type="date"
                              value={paymentDate}
                              onChange={e => setPaymentDate(e.target.value)}
                              required
                              style={{ width: "100%" }}
                            />
                          </Col>
                        </Row>
                  </Col>
                  <Col md={12} style={{ marginBottom: 10 }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label style={{ width: "100%" }}>Description:</label>
                    </Col>
                      <Col md={9}>
                        <Form.Control
                          as="textarea"
                          value={description}
                          rows={1}
                          onChange={(e) => {
                            const value = e.target.value;
                            const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                            setDescription(filteredValue);
                          }}
                          required
                          style={{ width: "100%" }}
                        />
                      </Col>
                  </Row>
                  </Col>
                  <Col md={12}>
                      <Row>
                        <Col md={3} style={{ textAlign: "right" }}>
                          <label>Mode:</label>
                        </Col>
                        <Col md={9}>
                          <Select
                            options={paymentMode}
                            value={selectedPaymentMode}
                            onChange={setSelectedPaymentMode}
                            placeholder="Payment Mode"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                        </Col>
                      </Row>
                  </Col>
              </Row>
              <Row>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Currency:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={currencyOptions}
                              value={selectedCurrency}
                              onChange={setSelectedCurrency}
                              placeholder="Currency"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Amount:</label>
                              </Col>
                              <Col md={8}>
                              <CurrencyInput
                                id="total-amount"
                                name="totalAmount"
                                value={amount}
                                decimalsLimit={2}
                                onValueChange={(value) => setAmount(value)}
                                // prefix="₦"
                                groupSeparator=","
                                placeholder="Amount"
                                className={`form-control ${classes.optioncss}`}
                              />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Expenses:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={bankOptions}
                              value={selectedBank}
                              onChange={setSelectedBank}
                              placeholder="Account"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Payables:</label>
                              </Col>
                              <Col md={8}>
                                <Select
                                  options={bankOptions2}
                                  value={selectedBank2}
                                  onChange={setSelectedBank2}
                                  placeholder="Account"
                                  isClearable
                                  classNamePrefix="react-select"
                                  required
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ paddingLeft: "25px", paddingRight: "25px" }}>
          <Button variant="light" onClick={handleClose1}>
            Go back
          </Button>
          <Button variant="success" onClick={addPayment} disabled={addpaymenntLoad} className={classes.btnss}>
              {addpaymenntLoad ? (
                <>
                  <Spinner size="sm" />
                  <span style={{ marginLeft: "5px" }}>
                    Processing, Please wait...
                  </span>
                </>
              ) : (
                "Save Payment"
              )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show2} onHide={handleClose2} size="xl"   
      dialogClassName={classes.customModal} centered >
        <Modal.Header closeButton style={{ padding: "15px 30px 10px 0", fontSize: "13px" }}>
          <Modal.Title style={{ fontSize: 18, padding: "10px 20px 0px 25px" }}><b>Add New Payable</b></Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "10px 30px 10px 30px" }}>
            <Row style={{ marginTop: 10, fontSize: "13px" }}>
              <Col md={12} style={{ marginBottom: 15 }}>
                <Row>
                  <Col md={4}>
                    <Form.Label style={{ marginBottom: 2, padding: 0 }}>Payable Type</Form.Label>
                      <Select
                        options={payablesType}
                        value={selectedPayableType}
                        onChange={handleBankChangeNew}
                        placeholder="Select Payable Type"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ keeps it on top

                          control: (base, state) => ({
                            ...base,
                            fontSize: "12px",
                            minHeight: "32px",
                            height: "32px",
                            padding: "0 4px",
                            borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                            boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                          }),

                          valueContainer: (base) => ({
                            ...base,
                            padding: "0 6px",
                            height: "28px",
                          }),

                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "28px",
                          }),

                          option: (base, state) => ({
                            ...base,
                            fontSize: "12px",
                            backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                            color: "black",
                          }),

                          menuList: (base) => ({
                            ...base,
                            maxHeight: "200px",
                            overflowY: "auto",
                          }),
                        }}
                      />
                  </Col>
                  <Col md={4}>
                    <Form.Label style={{ marginBottom: 2, padding: 0 }}>Supplier</Form.Label>
                      <Select
                        options={supplierOptions2}
                        value={selectedSupplier2}
                        onChange={(option) => {
                          if (option) {
                            setSelectedSupplier2(option);
                            setAccountExpenses(option?.expense || ""); // ✅ auto-fill expense_gl
                            setAccountPayables(option?.payable || ""); // ✅ auto-fill expense_gl
                            setAccountCode(option?.gl_code || ""); // ✅ auto-fill expense_gl
                          } else {
                            // if cleared, reset values
                            setSelectedSupplier2(null);
                            setAccountExpenses("");
                            setAccountPayables("");
                            setAccountCode("");
                          }
                        }}
                        placeholder="Select Supplier"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ keeps it on top

                          control: (base, state) => ({
                            ...base,
                            fontSize: "12px",
                            minHeight: "32px",
                            height: "32px",
                            padding: "0 4px",
                            borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                            boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                          }),

                          valueContainer: (base) => ({
                            ...base,
                            padding: "0 6px",
                            height: "28px",
                          }),

                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "28px",
                          }),

                          option: (base, state) => ({
                            ...base,
                            fontSize: "12px",
                            backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                            color: "black",
                          }),

                          menuList: (base) => ({
                            ...base,
                            maxHeight: "200px",
                            overflowY: "auto",
                          }),
                        }}
                      />                
                  </Col>
                  <Col md={4}>
                    <Form.Label style={{ marginBottom: 2, padding: 0 }}>Transaction Date</Form.Label>
                      <Form.Control
                        type="date"
                        // autoFocus
                        value={selectedDate}
                        onChange={handleDateChange}
                        name="date"
                        // min={minDate}
                        // max={maxDate}
                        style={{ fontSize: "13px", height: 32 }}
                      />
                  </Col>
                </Row>
              </Col>
              <Col md={12} style={{ marginBottom: 15 }}>
                <Row>
                  <Col md={6}>
                    <Form.Label style={{ marginBottom: 2, padding: 0 }}>Description</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Description"
                      // autoFocus
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      style={{ fontSize: "13px", height: 32 }}
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Label style={{ marginBottom: 2, padding: 0 }}>Mode of Payment</Form.Label>
                      <Select
                        options={paymentMode}
                        value={selectedPaymentMode}
                        onChange={setSelectedPaymentMode}
                        placeholder="Select Payment Mode"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ keeps it on top

                          control: (base, state) => ({
                            ...base,
                            fontSize: "12px",
                            minHeight: "32px",
                            height: "32px",
                            padding: "0 4px",
                            borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                            boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                          }),

                          valueContainer: (base) => ({
                            ...base,
                            padding: "0 6px",
                            height: "28px",
                          }),

                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "28px",
                          }),

                          option: (base, state) => ({
                            ...base,
                            fontSize: "12px",
                            backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                            color: "black",
                          }),

                          menuList: (base) => ({
                            ...base,
                            maxHeight: "200px",
                            overflowY: "auto",
                          }),
                        }}
                      />
                  </Col>
                  <Col md={3}>
                    <Form.Label style={{ marginBottom: 2, padding: 0 }}>Currency</Form.Label>
                      <Select
                        options={currencyOptions}
                        value={selectedCurrency}
                        onChange={setSelectedCurrency}
                        placeholder="Currency"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ keeps it on top

                          control: (base, state) => ({
                            ...base,
                            fontSize: "12px",
                            minHeight: "32px",
                            height: "32px",
                            padding: "0 4px",
                            borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                            boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                          }),

                          valueContainer: (base) => ({
                            ...base,
                            padding: "0 6px",
                            height: "28px",
                          }),

                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "28px",
                          }),

                          option: (base, state) => ({
                            ...base,
                            fontSize: "12px",
                            backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                            color: "black",
                          }),

                          menuList: (base) => ({
                            ...base,
                            maxHeight: "200px",
                            overflowY: "auto",
                          }),
                        }}
                      />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row style={{ fontSize: "12px" }}>
            {((selectedPayableType?.value == 2) || (selectedPayableType?.value == 3) || (selectedPayableType?.value == 4)) ? (
              <>
                {/* <Col md={4} style={{ marginBottom: 10 }}>
                  <Form.Label style={{ marginBottom: 2, padding: 0 }}>Account Expenses</Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={accountExpenses}
                    onChange={(e) => setAccountExpenses(e.target.value)}
                    style={{ fontSize: "13px", height: 38 }}
                  />
                </Col> */}
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0 }}>Account Payables</Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={accountPayables}
                    onChange={(e) => setAccountPayables(e.target.value)}
                    style={{ fontSize: "13px", height: 32 }}
                  />
                </Col>
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0 }}>Amount</Form.Label>
                  <CurrencyInput
                    id="total-amount"
                    name="totalAmount"
                    value={amount}
                    decimalsLimit={2}
                    onValueChange={(value) => setAmount(value)}
                    // prefix="₦"
                    groupSeparator=","
                    placeholder="Enter Amount"
                    style={{ fontSize: "13px", height: 32, textAlign: "right" }}
                    className={`form-control ${classes.optioncss}`}
                  />
                </Col>
              </>
              ):(
              <>
              {/* <Col md={4} style={{ marginBottom: 10 }}>
                <Form.Label style={{ marginBottom: 2, padding: 0 }}>Account Expenses</Form.Label>
                <Select
                  options={bankOptions}
                  value={selectedBank}
                  onChange={setSelectedBank}
                  placeholder="Select an Option"
                  isClearable
                  classNamePrefix="react-select"
                  required
                />
              </Col> */}
              <Col md={4}>
                <Form.Label style={{ marginBottom: 2, padding: 0 }}>Account Payables</Form.Label>
                <Select
                  options={bankOptions2}
                  value={selectedBank2}
                  onChange={setSelectedBank2}
                  placeholder="Select an Option"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ keeps it on top

                    control: (base, state) => ({
                      ...base,
                      fontSize: "12px",
                      minHeight: "32px",
                      height: "32px",
                      padding: "0 4px",
                      borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                      boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                    }),

                    valueContainer: (base) => ({
                      ...base,
                      padding: "0 6px",
                      height: "28px",
                    }),

                    indicatorsContainer: (base) => ({
                      ...base,
                      height: "28px",
                    }),

                    option: (base, state) => ({
                      ...base,
                      fontSize: "12px",
                      backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                      color: "black",
                    }),

                    menuList: (base) => ({
                      ...base,
                      maxHeight: "200px",
                      overflowY: "auto",
                    }),
                  }}
                />
              </Col>
              <Col md={4}>
                <Form.Label style={{ marginBottom: 2, padding: 0 }}>Amount</Form.Label>
                <CurrencyInput
                  id="total-amount"
                  name="totalAmount"
                  value={amount}
                  decimalsLimit={2}
                  onValueChange={(value) => setAmount(value)}
                  // prefix="₦"
                  groupSeparator=","
                  placeholder="Enter Amount"
                  style={{ fontSize: "13px", height: 32, textAlign: "right" }}
                  className={`form-control ${classes.optioncss}`}
                />
              </Col>
              </>
            )}
            </Row>
            {/* {selectedPayableType?.value == 1 && (
            <Row style={{ marginTop: 15, fontSize: "12px" }}>
              <Col md={6}>
                <Form.Label style={{ marginBottom: 2, padding: 0 }}>Account Payables</Form.Label>
                <Select
                  options={bankOptions2}
                  value={selectedBank2}
                  onChange={setSelectedBank2}
                  placeholder="Select an Option"
                  isClearable
                  classNamePrefix="react-select"
                  required
                />
              </Col>
            </Row>
            )} */}
          <Modal.Title style={{ fontSize: 18, padding: "15px 20px 15px 0px" }}><b>Account Breakdown</b></Modal.Title>
            <div className={classes.mainTable} style={{ paddingBottom: 30 }}>
              <div className="table-responsive" style={{ maxHeight: '200px', overflowY: 'auto', }}>
                <table className="table display bg-white m-0 card-table">
                  <thead style={{ whiteSpace: "nowrap", textAlign: "left", }}>
                    <tr style={{ padding: "2px 10px", margin: "2px 10px", fontSize: 13 }}>
                      <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, width: "30%", padding: "7px 10px", margin: "7px 10px"}}>Account Name</th>
                      <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, width: "30%", padding: "7px 10px", margin: "7px 10px"}}>Account Code</th>
                      <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, textAlign: "right", width: "15%", padding: "7px 10px", margin: "7px 10px"}}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr style={{ padding: "5px 10px", margin: "2px 10px", fontSize: 13 }}>
                    <td style={{ padding: "5px 10px", margin: "2px 10px" }}>
                      {((selectedPayableType?.value == 2) || (selectedPayableType?.value == 3) || (selectedPayableType?.value == 4)) ? (
                        <>
                          <Form.Control
                            type="text"
                            disabled
                            value={accountExpenses}
                            onChange={(e) => setAccountExpenses(e.target.value)}
                            style={{ fontSize: "13px", height: 32 }}
                          />
                        </>
                        ):(
                          <>
                            <Select
                              options={bankOptions}
                              value={selectedBank}
                              placeholder="Select an Option"
                              isClearable
                              onChange={(option) => {
                                // ✅ Update the selected option to show it inside the box
                                setSelectedBank(option);

                                if (option) {
                                  setAccountCode(option?.gl_code || ""); // ✅ auto-fill expense_gl
                                } else {
                                  // if cleared, reset values
                                  setAccountCode("");
                                }
                              }}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ keeps it on top

                                control: (base, state) => ({
                                  ...base,
                                  fontSize: "12px",
                                  minHeight: "32px",
                                  height: "32px",
                                  padding: "0 4px",
                                  borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                                  boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                                }),

                                valueContainer: (base) => ({
                                  ...base,
                                  padding: "0 6px",
                                  height: "28px",
                                }),

                                indicatorsContainer: (base) => ({
                                  ...base,
                                  height: "28px",
                                }),

                                option: (base, state) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                                  color: "black",
                                }),

                                menuList: (base) => ({
                                  ...base,
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                }),
                              }}
                            />
                          </>
                        )}
                    </td>
                    <td style={{ padding: "5px 10px", margin: "2px 10px" }}>
                      <Form.Control
                        type="text"
                        value={accountCode}
                        disabled
                        onChange={(e) => setAccountCode(e.target.value)}
                        required
                        style={{ width: "100%", fontSize: "13px", height: 32 }}
                      />                                            
                    </td>
                    <td style={{ textAlign: "right", padding: "5px 10px", margin: "2px 10px" }}>
                      <CurrencyInput
                        id="total-amount"
                        name="totalAmount"
                        value={amount}
                        decimalsLimit={2}
                        disabled
                        onValueChange={(value) => setAmount(value)}
                        // prefix="₦"
                        groupSeparator=","
                        placeholder="Enter Amount"
                        style={{ fontSize: "13px", height: 32, textAlign: "right" }}
                        className={`form-control ${classes.optioncss}`}
                      />
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
        </Modal.Body>
        <Modal.Footer style={{ padding: "40px 30px 10px 30px" }}>
          <Button variant="light" onClick={handleClose2}>
            Go back
          </Button>
          <Button variant="success" onClick={addPayment2} disabled={addpaymenntLoad2} className={classes.btnss}>
              {addpaymenntLoad2 ? (
                <>
                  <Spinner size="sm" />
                  <span style={{ marginLeft: "5px" }}>
                    Processing, Please wait...
                  </span>
                </>
              ) : (
                "Add Payable"
              )}
          </Button>
        </Modal.Footer>
      </Modal>
    <Modal size='lg' show={showPaymentModal} onHide={() => setShowPaymentModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Payments - Bulk Entries</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="form-group row">
      <label
       
      >
        Transaction Date:
      </label>
      <div >
        <input
          className="form-control"
          required
          type="date"
          onChange={handleDateChange}
          name="date"
          value={selectedDate}
          // min={minDate}
          // max={maxDate}
          style={{  }}
        />
      </div>
    </div>

    <div style={{marginTop: 10}}/>
      <label>
        Bank:
      </label>
    <Select
      options={selectOptions1}
      placeholder="Select Bank"
      onChange={handleBankChange}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (provided) => ({
          ...provided,
          maxHeight: '300px',
          overflowY: 'auto',
        }),
      }}
    />
  <div style={{marginTop: 10}}/>
  <label>
    Description:
  </label>
  <div>
    <input
      className="form-control"
      required
      name="description"
      value={description}
      onChange={(e) => setDescription(e.target.value)}
      // rows={1} // adjust height
      style={{ resize: "vertical" }} // user can resize vertically if needed
    />
  </div>
<div style={{marginBottom: 10}}/>
  <table className={classes.invoiceTable}>
    <table className={classes.invoiceTable}>
      <thead>
        <tr>
          <th>S/N</th>
          <th>Beneficiary</th>
          <th>Description</th>
          <th>Total Amount</th>
          <th>Amount Paid</th>
          <th>Balance</th>
          <th>Amount To Pay</th>
        </tr>
      </thead>
      <tbody>
        {selectedRows.map((row, index) => (
          <tr key={row.id}>
            <td>{index + 1}</td>
            {/* <td>{row.transaction_date}</td> */}
            <td>{row.supplier?.name || row.customer?.name}</td>
            <td>{row.description}</td>
            {/* <td>{row.invoice_number}</td> */}
            <td style={{ textAlign: "right" }}>
              {parseFloat(row.amount).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </td>
            <td style={{ textAlign: "right" }}>
              {parseFloat(row.amount_paid).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </td>
            <td style={{ textAlign: "right" }}>
              {parseFloat(row.balance).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </td>
            <td>
            <input
                type="number"
                className="form-control"
                style={{ fontSize: "12px" }}
                value={row.amountToPay ?? row.balance}   // prefill with total amount
                min="0"
                max={row.balance}                       // restrict max to total amount
                onChange={(e) => {
                  let newValue = parseFloat(e.target.value);

                  if (isNaN(newValue)) newValue = 0;
                  if (newValue > parseFloat(row.balance)) {
                    newValue = parseFloat(row.balance);
                  }
                  setSelectedRows((prev) =>
                    prev.map((r) =>
                      r.id === row.id ? { ...r, amountToPay: newValue } : r
                    )
                  );
                }}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </table>

  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowPaymentModal(false)}>
      Cancel
    </Button>
    <Button style={{whiteSpace: "nowrap"}} className={classes.btnss} disabled={selectedRows.length === 0 || !selectedBank || !selectedDate || !description} onClick={handleConfirmPaymentInstruction}>
      Generate Instruction
    </Button>
    <Button style={{whiteSpace: "nowrap"}} className={classes.btnss} disabled={selectedRows.length !== 1 || !selectedBank || !selectedDate || !description}  onClick={handleNavCheque}>
      Print Cheque
    </Button>
  </Modal.Footer>
</Modal>
       {/* <PayableEntryModal
                      isOpen={show2}
                      onClose={() => setShow2(false)}
                  /> */}

      {/* <Footer /> */}
    </div>
  );
};

export default PayablesEntries;
